import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import RecurrentProblemOrderContainer from './RecurrentProblemOrderContainer';
import recurrentProblemMessages from '../../../intl/sparePartsOrders/recurrentProblemMessages';
import {domains} from '../../../constants/Utils';
import PageHeader from '../../common/PageHeader';
import checkRoles from '../../common/roleChecker/RoleChecker';
import styled from 'styled-components';
import Get from 'get-value';
import {moduleRoles} from '../../../utils/roles';
import SelectCountryGroup from '../../common/country/SelectCountryGroup';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {storeSelectedCountryGroup} from '../../../actions/orders/actionSparePartsRecurrentProblem';

const domain = domains.SPARE_PARTS;

const Label = styled.label`
    font-weight: bold;
`;

const StyledForm = styled.form`
    padding-top: 5px;
    position: relative;
    margin: 0 auto;
`;

class RecurrentProblemOrderPage extends Component {
    componentDidMount() {
        if (this.props.selectedCountryGroup === '') {
            this.props.storeSelectedCountryGroup(
                Get(moduleRoles.getEditorGroups(domain, this.props.roles), '0.group', this.props.group)
            );
        }
    }

    handleCountryGroupSelection = countryGroup => this.props.storeSelectedCountryGroup(countryGroup.value);

    render() {
        const { roles, selectedCountryGroup } = this.props;
        let groups = this.props.group ? [{group: this.props.group, value: true}] : [];
        if (moduleRoles.isEditorOrder(this.props.roles)) {
            groups = moduleRoles.getEditorGroups(domain, roles);
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage {...recurrentProblemMessages.TITLE}/>}/>
                {moduleRoles.isEditorOrder(roles) &&
                <StyledForm className="form-group">
                    <div className="form-row mb-sm-3">
                        <div className="col-xl-2 col-lg-4 col-md-5 col-sm-6">
                            <Label>
                                <FormattedMessage {...recurrentProblemMessages.SELECT_COUNTRY}/>
                            </Label>
                            <SelectCountryGroup groups={groups}
                                                handleCountryGroupSelection={this.handleCountryGroupSelection}
                                                selectedCountryGroup={selectedCountryGroup}/>
                        </div>
                    </div>
                </StyledForm>
                }
                {groups.map((group, index) =>
                    (selectedCountryGroup === group.group &&
                        <div key={index}>
                            <RecurrentProblemOrderContainer domain={domain} selectedGroup={selectedCountryGroup}/>
                        </div>
                    )
                )}
            </div>
        );
    }
}

RecurrentProblemOrderPage.propTypes = {
    roles: PropTypes.object.isRequired,
    group: PropTypes.string,
    selectedCountryGroup: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    roles: state.profile.userDetail.roles,
    group: state.profile.userDetail.group,
    selectedCountryGroup: state.sparePartsRecurrentProblem.selectedCountryGroup
});

export default checkRoles(connect(mapStateToProps, {
    storeSelectedCountryGroup
})(RecurrentProblemOrderPage), ['SP_DEALER', 'SP_EDITOR', 'SP_SG_EDITOR']);
